// external imports
import React from 'react'
import { createFragmentContainer, graphql } from 'react-relay'
import { FlexRow, FlexColumn } from 'quark-web'
// local imports
import { ProductCharacteristics, LocationBilling } from '~/components'
import { Header, Text, Logo } from '~/components'
import styles from './styles'

const PrintProductContent = ({ product }) => (
    <FlexColumn style={{ padding: 24 }}>
        <FlexRow justifyContent="space-between" alignItems="center">
            <div style={styles.logo}>
                <Logo onLoad={window.print} />
            </div>
            <LocationBilling showMap={false} />
        </FlexRow>
        {product.category.family && (
            <Text style={{ fontSize: 24, marginTop: 8 }}>{product.category.family.name} –</Text>
        )}
        <Text style={{ fontSize: 24, marginTop: 8 }}>{product.category.name}</Text>
        <FlexRow grow={1}>
            <FlexColumn style={{ width: 360, marginRight: 24 }}>
                {product.files.edges
                    .slice(0, 3)
                    .map(({ node }, i) => <img key={i} src={node.url} style={styles.img} />)}
            </FlexColumn>
            <FlexColumn grow={1} style={{ width: 10 }}>
                <FlexRow>
                    <Text>{product.description.trim()}</Text>
                </FlexRow>
                <FlexRow>
                    <ProductCharacteristics product={product} />
                </FlexRow>
            </FlexColumn>
        </FlexRow>
    </FlexColumn>
)

export default createFragmentContainer(
    PrintProductContent,
    graphql`
        fragment PrintProductContent_product on Product {
            id
            name
            description
            files {
                edges {
                    node {
                        url
                    }
                }
            }
            category {
                name
                family {
                    name
                }
            }
            ...ProductCharacteristics_product
        }
    `
)



// WEBPACK FOOTER //
// ./src/views/PrintProduct/PrintProductContent.js